var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar'),_c('div',{staticClass:"main"},[_c('banner'),_c('experiences'),_c('uber'),_c('features'),_c('Ticketing'),_c('ReasonToUseMYLE'),_c('ticketEvents'),_c('about'),_c('screenshots',{attrs:{"is-gray":true}}),_c('clients'),_c('contact',{attrs:{"is-gray":false}}),_c('key-features',{attrs:{"is-green":true}}),_c('site-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }